// Hide the mobile bottom nav while the product page buy buttons are on screen,
// so the floating bar never covers Add to bag / Buy now.
(() => {
  const nav = document.querySelector('.new-mob-bottom-main');
  const buyButtons = document.querySelector('product-info[id^="MainProduct-"] .product-form__buttons');
  if (!nav || !buyButtons) return;

  new IntersectionObserver(([entry]) => {
    nav.classList.toggle('new-mob-bottom-main--cta-visible', entry.isIntersecting);
  }).observe(buyButtons);
})();
